var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class FlagsApiStrategy {
    /**
     * Flags api config.
     */
    constructor(config) {
        /** Local cache. */
        this.cache = new Map();
        this.config = config;
    }
    /**
     * Initialize.
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const { flags, fetch } = this.config;
            // Prefetch flags
            const responses = yield Promise.all(flags.map((f) => fetch(f)));
            // Flags cache
            for (let i = 0, n = flags.length; i < n; i++) {
                this.cache.set(flags[i], responses[i].enabled);
            }
        });
    }
    /**
     * Feature is enabled.
     * @param name Feature name.
     */
    isEnabled(name) {
        var _a;
        return (_a = this.cache.get(name)) !== null && _a !== void 0 ? _a : false;
    }
}
